import styled from 'styled-components/macro';
import SimpleList from 'styled/SimpleList';

const List = styled(SimpleList)`
  display: flex;
  align-items: center;
  min-height: 32px;
`;

export default List;
